// JS Dependencies: Bootstrap & JQuery
import 'bootstrap';
import 'jquery';
// Using the next two lines is like including partial view _ValidationScriptsPartial.cshtml
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

Vue.use(Vuex);
Vue.use(VueRouter);

import Notifications from 'vue-notification'
Vue.use(Notifications);

import Config from './common/config';
Vue.config.productionTip = Config.productionTip;

import store from 'store/login.store';

import Login from './views/login/login.vue';

const router = new VueRouter({
    routes: [
        { path: '/', component: Login },
        { path: '*', redirect: '/'}
    ]
});

async function main() {
    //await setWijmoLicense();

    new Vue({
        router,
        store,
    }).$mount('#app');
}
main().catch(e => console.error(e));

